import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Navigate } from "react-router-dom";
import SuccessModal from "./shared/SuccessModal";

const DeleteAccount = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalConfig, setModalConfig] = useState({
      success: false,
      message: ""
    });
  const [formData, setFormData] = useState({
    userData: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const navigate=useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
     setLoading(true);

    try {
      const URL = `${process.env.REACT_APP_API_URL}users/deleteUser`;
      const response = await axios.delete(URL, { data: formData });
      if (response.status === 200) {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("userType");
        localStorage.removeItem("username");
        localStorage.removeItem("userid");
        localStorage.removeItem("usertype");

        setModalConfig({
          success: true,
          message: "Profile deleted successfully.",
          onClose: () => {
            setShowModal(false);
            navigate('/candidatedashboard')
            window.location.reload(); 
          },
        });        
      } else {
        setModalConfig({
          success: false,
          message: "Can't find user or already deleted",
          onClose: () => setShowModal(false),
        });
      }
    } catch (error) {
      console.error(error);
      setModalConfig({
        success: false,
        message: "Can't delete profile, please try again.",
        onClose: () => setShowModal(false),
      });
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const userType = localStorage.getItem('userType');

  let targetPath = '/';
  if (userType === 'candidate') {
    targetPath = '/candidatedashboard';
  } else if (userType === 'employer') {
    targetPath = '/employerdashboard';
  }

  return (
    <div className="col-lg-9">
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <div className="container mx-auto max-w-md my-3 mb-4 my-5 mt-8">
            <h2 className="text-xl font-semibold mb-4">Delete Your Account</h2>
            <p className="text-base text-gray-600 mb-5">
              Enter your username, email, or mobile number, along with your password to delete your account.
            </p>
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="form-section">
                  <form onSubmit={handleSubmit}>
                    <div className="form-item">
                      <label htmlFor="username" className="form-label text-lg font-semibold h5">
                        Username, Email, or Mobile*
                      </label>
                      <input
                        type="text"
                        id="username"
                        value={formData.userData}
                        onChange={handleChange}
                        className="form-control text-lg p-3 h5"
                        placeholder="Enter your username, email, or mobile"
                        name="userData"
                        required
                      />
                    </div>

                    <div className="form-item mt-4">
                      <label htmlFor="password" className="form-label text-lg font-semibold h5">
                        Password*
                      </label>
                      <input
                        type="password"
                        id="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control text-lg p-3 h5"
                        placeholder="Enter your password"
                        name="password"
                        required
                      />
                    </div>

                    <div className="form-btn d-flex gap-2 mt-4">
                    <button type="submit" className="btn btn-danger m-2" disabled={loading}>
                        {loading ? "Deleting..." : "Delete"}
                      </button>
                      <Link  to={targetPath}  className="btn btn-warning m-2">
                        Cancel
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="mt-5 text-gray-600">
              <p className="text-danger">
                By deleting your account, you agree that it will be permanently removed after 30 days. If you wish to restore it, you can log in within this period before the deletion is final.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={{color:"red"}}>
  <SuccessModal 
    show={showModal}
    onClose={modalConfig.onClose}
    success={modalConfig.success}
    message={modalConfig.message}
  />
</div>

      
    </div>  
  
    
  );
};

export default DeleteAccount;
